import { render, staticRenderFns } from "./DetalleAgendamientoTutorias.vue?vue&type=template&id=639358f9&"
import script from "./DetalleAgendamientoTutorias.vue?vue&type=script&lang=js&"
export * from "./DetalleAgendamientoTutorias.vue?vue&type=script&lang=js&"
import style0 from "./DetalleAgendamientoTutorias.vue?vue&type=style&index=0&id=639358f9&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports